import { render, staticRenderFns } from "./BuildManagementVulkan.vue?vue&type=template&id=13c4b3de&scoped=true"
import script from "./BuildManagementVulkan.vue?vue&type=script&lang=js"
export * from "./BuildManagementVulkan.vue?vue&type=script&lang=js"
import style0 from "./BuildManagementVulkan.vue?vue&type=style&index=0&id=13c4b3de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c4b3de",
  null
  
)

export default component.exports